import analyticsService, { AnalyticsEvent } from 'services/AnalyticsService';
import { RootDispatch } from '../types';
import { NotificationItem } from './types';
import { toggleNotificationsPreference } from './actions';
import { Screens } from './constants';

const sendNotificationsToggleEvent = (item: NotificationItem) => {
  const type = item.key;
  if (!['FCM', 'APN', 'EMAIL', 'SMS'].includes(type)) return false;
  const typeName = type.concat('NotificationsToggled') as keyof typeof AnalyticsEvent;
  const action = item.enabled ? 'deactivate' : 'activate';

  analyticsService.logEvent(AnalyticsEvent[typeName], {
    currentUrl: Screens.NOTIFICATIONS_OPT_OUT,
    referringUrl: 'Login',
    action
  });
  return true;
};

export const toggleNotificationsPreferenceWithAnalytics = (
  item: NotificationItem,
  type: 'channels' | 'categories',
  returnBackTo?: keyof typeof Screens
) => async (dispatch: RootDispatch) => {
  sendNotificationsToggleEvent(item);
  await dispatch(toggleNotificationsPreference(item, type, false, returnBackTo));
};
